export default __webpack_public_path__ + "static/media/liam.dacdc962.jfif";